import { render, staticRenderFns } from "./orderFundList.vue?vue&type=template&id=f810fb96"
import script from "./orderFundList.vue?vue&type=script&lang=js"
export * from "./orderFundList.vue?vue&type=script&lang=js"
import style0 from "./orderFundList.vue?vue&type=style&index=0&id=f810fb96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports